import { translateFr as tfr } from "@/i18n";
// Career Plan Builder — client-side helpers (catalogs come from the backend)

export const OWNER_OPTIONS = [
  { id: "agent", label: "Agent" },
  { id: "athlete", label: tfr("Athlète") },
  { id: "club", label: "Club" },
  { id: "coach", label: "Coach" },
];
export const PRIORITY_META = {
  low: { label: "Faible", cls: "bg-secondary text-muted-foreground border-border", dot: "#9CA3AF" },
  medium: { label: "Moyenne", cls: "bg-warning/15 text-warning border-warning/30", dot: "#F59E0B" },
  high: { label: "Haute", cls: "bg-danger/15 text-danger border-danger/30", dot: "#E11D2E" },
};
export const IDENTITY_LABELS = [
  ["name", "Nom"], ["sport_label", "Sport"], ["position", "Poste"], ["club", "Club"],
  ["league", "Championnat / niveau"], ["nationality", tfr("Nationalité")], ["age", tfr("Âge")],
  ["foot", "Pied / main fort(e)"], ["height", "Taille"], ["weight", "Poids"], ["languages", "Langues"],
];
export const QR_OPTIONS = [
  { id: "athlete", label: tfr("Profil athlète") },
  { id: "negotiation", label: tfr("Fiche de négociation") },
  { id: "career", label: tfr("Plan de carrière") },
  { id: "custom", label: tfr("URL personnalisée") },
];
export const HIGHLIGHT_SUGGESTIONS = [
  "Premier contrat professionnel", "Montée de division", "Meilleure saison en carrière",
  "International jeunes", "Capitaine de son équipe", "Trophée individuel",
];

export function completionColor(score) {
  if (score >= 80) return "text-success";
  if (score >= 50) return "text-warning";
  return "text-danger";
}
export function scoreHex(v) {
  if (v === null || v === undefined) return "#9CA3AF";
  return v >= 70 ? "#16A34A" : v >= 45 ? "#F59E0B" : "#E11D2E";
}
export const MS_STATUS = {
  completed: { label: "Atteint", hex: "#16A34A" },
  in_progress: { label: tfr("En cours"), hex: "#3B82F6" },
  upcoming: { label: tfr("À venir"), hex: "#9CA3AF" },
  at_risk: { label: tfr("À risque"), hex: "#F59E0B" },
  delayed: { label: tfr("Retardé"), hex: "#E11D2E" },
};
export function chipLabel(catalogs, group, id) {
  const item = (catalogs?.[group] || []).find((c) => c.id === id);
  return item?.label || id;
}
export function readinessLabel(v) {
  const en = (() => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } })();
  if (v === null || v === undefined) return "—";
  return v >= 80 ? (en ? "Ready" : "Prêt") : v >= 50 ? (en ? "Progressing" : "En progression") : (en ? "To strengthen" : "À renforcer");
}
